module.exports = __webpack_public_path__ + "img/c29381c.jpg";